<template>
    <div class="mainPage">
        <div class="topBox"><i class="el-icon-back mr10 f20" @click="goBack"></i>优惠券操作记录</div>
           <div class="mainBox">
                <el-row >
                    <el-form >
                        <el-col :span="4">
                            <el-form-item label="操作类型" label-width="80px">
                                <el-select v-model="searchForm.operateType" placeholder="请选择">
                                    <el-option
                                        v-for="item in operateTypeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="操作人" label-width="80px">
                                <el-select v-model="searchForm.operaterList" filterable  multiple collapse-tags clearable  placeholder="请选择">
                                    <el-option
                                        v-for="item in operaterList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="9">
                            <el-form-item label="操作时间" label-width="80px">
                                <el-date-picker
                                    v-model="searchForm.opearteTime"
                                    type="datetimerange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        
                      <el-button type="primary" class="ml10" @click="search"
                        ><i class="el-icon-search el-icon--left fw600"></i>查询</el-button
                        >
                        <el-button type="" @click="reSet"
                        ><i
                            v-if="!isLoading"
                            class="el-icon-refresh-right el-icon--left fw600"
                        ></i
                        ><i v-if="isLoading" class="el-icon-loading el-icon--left fw600"></i
                        >重置</el-button
                        >
                    </el-form>
                </el-row>
                <el-row>
                 <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" >
                    <el-table-column prop="operateType" label="操作类型" align="center"  > 
                      <template slot-scope="scope">
                         {{scope.row.operateType == '1' ? '创建':scope.row.operateType == '2' ? '编辑':scope.row.operateType == '3' ? '批量新增门店':
                         scope.row.operateType == '4' ? '批量替换门店':scope.row.operateType == '5' ? '恢复':scope.row.operateType == '6' ? '删除':'-'
                         }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="operater" label="操作人" align="center" > </el-table-column>
                    <el-table-column prop="opearteTime" label="操作时间" align="center" show-overflow-tooltip="" > </el-table-column>
                    <el-table-column prop="opearteContent" label="操作内容" align="center" > 
                        <template slot-scope="scope">
                           {{scope.row.opearteContent ? scope.row.opearteContent:'-' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="opearteStatus" label="操作状态" align="center" > 
                        <template slot-scope="scope">
                           {{scope.row.opearteStatus == '1' ? '成功':'失败' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="opearteAddress" label="操作地址" align="center" > </el-table-column>
                  </el-table>
                      <div class="footerBox" v-if="total>10">
                        <!-- 分页区域 -->
                        <el-pagination
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page.sync="queryInfo.currPage"
                          :page-sizes="[10, 20, 30, 50]"
                          :page-size="queryInfo.pageSize"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="total"
                        ></el-pagination>
                      </div>
              </el-row>
           </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            total:0,
            tableData:[
                {
                   operateType:'1',
                   operater:'测试/00002',
                   opearteTime:'2023/08/02 15:25:07',
                   opearteContent:'',
                   opearteStatus:'1',
                   opearteAddress:'安徽省合肥市',
                },
            ],
          isLoading:false,
          queryInfo:{
             pageSize: 10,
             currPage: 1,
             condition:{
               
             }
          },
          searchForm:{
            operateType:'1',
            operaterList:[],
            opearteTime:[],
          },
          operateTypeList:[
            {
              label:'全部',
              value:'1',
            },
            {
              label:'创建',
              value:'2',
            },
            {
              label:'编辑',
              value:'3',
            },
            {
              label:'批量新增门店',
              value:'4',
            },
            {
              label:'批量替换门店',
              value:'5',
            },
            {
              label:'恢复',
              value:'6',
            },
            {
              label:'删除',
              value:'7',
            },
          ],
          operaterList:[
            {
              label:'测试',
              value:'00002',
            },
            {
              label:'杨总',
              value:'00001',
            },
          ],
        }
    },
    methods:{
        //搜索
        search(){

        },
        //重置
        reSet(){
           this.searchForm = {
            operateType:'1',
            operaterList:[],
            opearteTime:[],
          }
        },
       //返回
        goBack (){
            this.$router.push({path:'/couponManage'})
        },
        // 监听 pagesize改变的事件
        handleSizeChange(newSize) {
        this.queryInfo.pageSize = newSize;
        //   this.getListData();
        },
        // 监听 页码值 改变事件
        handleCurrentChange(newSize) {
        this.queryInfo.currPage = newSize;
        //   this.getListData();
        },
    }
}
</script>

<style lang="less" scoped>
.mainPage {
  width: 99%;
  height: 90vh;
  /* padding: 30px; */
  background: #fff;
  overflow-y: scroll;
}
.topBox{
    /* width: 100%; */
    display: flex;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #ddd;
}
.f20{
    font-size: 20px;
    cursor: pointer;
}
/deep/ .el-select .el-input.is-focus .el-input__inner {
  border: 1px solid #f59a23 !important;
}
/deep/  .el-select-dropdown__item.selected span{
     color:#222 !important;
}
.mainBox{
    /* width: 100%; */
    // height: 70vh;
    // background:#fff;
    padding: 30px;
    // overflow-y: scroll;
}
/deep/ .el-date-editor--datetimerange.el-input, .el-date-editor--datetimerange.el-input__inner{
    width: 100%;
}
/deep/ .el-button--primary {
  background-color: rgb(245, 154, 35);
  border-color: rgb(245, 154, 35);
}
/deep/ .el-button:focus,
.el-button:hover {
  color: rgb(245, 154, 35);
  border-color: #f5dab1;
  background-color: #fdf6ec;
}
/deep/ .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{
      color: #C0C4CC;
    cursor: not-allowed;
    background-image: none;
    background-color: #FFF;
    border-color: #EBEEF5;
}
 /deep/ .el-table th>.cell{
    font-size: 15px;
    color: #222;
    font-weight: 500;
    padding: 8px 0;
 }
  /deep/ .el-table th, /deep/ .el-table tr{
    font-size: 14px;
    color: #222;
 }
</style>